// extracted by mini-css-extract-plugin
export default {"root":"Home_root__LmqQU","link":"Home_link__2MEKD","Home":"Home_Home__oQig8"};